import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Sidebar from "./components/sidebar";
import Header from "./components/header";
import "../../assets/css/clients/styleNew.css";
import { Screener, ForexHeatMap } from "react-tradingview-embed";
import { getSignal } from "../../server/firebase.config";
import { firstValueFrom } from "rxjs";

const Signals = () => {
  // <!-- ////////// PRODUCT OF OBSIDIAN INC., WRITTEN AND DESIGNED BY GROOVE DEVELOPERS INC. YOU ARE PROHIBITED FROM USING OR EDITING
  // THIS APPLICATION WITHOUT INFORMING GROOVE DEVELOPERS INC AND OBSIDIAN INC. ///////////-->

  const [signals, setSignals] = useState(null);


  const effect = useEffect(() => {
    firstValueFrom(getSignal())
      .then((item) => {
        // console.log(item);
        setSignals(item);
      })
      .catch((error) => {
        console.log(error);
      });

     
  }, []);

  return (
    <div>
      <Container fluid>
        <Row>
          <Col md="2" className="sidebar-col">
            <Sidebar></Sidebar>
          </Col>
          <Col sm="12" md="10" className="mainbody">
            <Header></Header>

            <div className="clearfix"></div>
            <div className="mb ">
              <Container fluid>
                <Row>
                  <Col
                    sm="12"
                    md="6"
                    className="dashboard_weather_cols"
                    style={{
                      height: "50vh",
                     
                      marginLeft: "-10px",
                    }}
                  >
                    <div className="chart_cards"
                      style={{
                        marginTop: "20px",
                        height: "45vh",
                        overflowX: "scroll",
                        
                      }}
                    >
                      <Screener
                        widgetProps={{
                          width: "100%",
                          //   height: "50vh",
                          timezone: "Europe/Berlin",
                          theme: "light",
                          style: "1",
                          locale: "en",
                          toolbar_bg: "#f1f3f6",

                          showSymbolLogo: true,
                          // isTransparent: true,
                          displayMode: "adaptive",
                          isTransparent: true,
                          locale: "en",
                          details: true,
                          container_id: "tradingview_d89b8",
                        }}
                      />
                    </div>
                  </Col>
                  <Col
                    sm="12"
                    md="6"
                    className="dashboard_weather_cols"
                    style={{ height: "50vh", padding: "10px" }}
                  >
                    <div className="chart_cards"
                      style={{
                        marginTop: "10px",
                        marginLeft: "-10px",
                        height: "45vh",
                        overflowX: "scroll",
                      }}
                    >
                      <ForexHeatMap
                        widgetProps={{
                          width: "100%",
                          //   height: "50vh",
                          timezone: "Europe/Berlin",
                          theme: "light",
                          style: "1",
                          locale: "en",
                          toolbar_bg: "#f1f3f6",

                          showSymbolLogo: true,
                          // isTransparent: true,
                          displayMode: "adaptive",
                          isTransparent: true,
                          locale: "en",
                          details: true,
                          container_id: "tradingview_d89b8",
                        }}
                      />
                    </div>
                  </Col>




                  <Col
                    sm="12"
                    md="12"
                    className="dashboard_weather_cols"
                    style={{
                      height: "70vh",
                      width: "100%",
                      overflow: "hidden",
                      marginTop: "30px",
                    }}
                  >
                    <Row>
                      {signals?.map((item) => (
                        <Col sm="12" md="3" className="signal_box">
                          <div className="signal_box_img">
                            <img src="" />
                          </div>

                          <div className="signal_box_title">{item?.title}</div>

                          <div className="signal_box_type">
                            <div className="signal_box_type_title">Type</div>

                            <div
                              className="signal_box_type_body"
                              style={{
                                color: ` ${
                                  item?.type === "buy" ? "green" : "red"
                                }`,
                              }}
                            >
                              {item?.type}
                            </div>
                          </div>
                          <div className="signal_box_type">
                            <div className="signal_box_type_title">
                              Entry Price
                            </div>

                            <div
                              className="signal_box_type_body"
                              style={{ color: "blue" }}
                            >
                              {item?.price}
                            </div>
                          </div>

                          <div className="signal_box_type">
                            <div className="signal_box_type_title">
                              Stop Loss
                            </div>

                            <div
                              className="signal_box_type_body"
                              style={{ color: "red" }}
                            >
                              {item?.stopLoss}
                            </div>
                          </div>

                          <div className="signal_box_type">
                            <div className="signal_box_type_title">
                              Take Profit
                            </div>

                            <div className="signal_box_type_body">
                              {item?.takeProfit}
                            </div>
                          </div>

                          <div className="signal_box_type">
                            <div className="signal_box_type_title">Status</div>

                            <div
                              className="signal_box_type_body"
                              style={{
                                color: ` ${
                                  item?.status === "active" ? "green" : "red"
                                }`,
                              }}
                            >
                              {item?.status}
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>

                 
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Signals;
